<template>
  <div>
    <div class="comment-header">
      <van-nav-bar
        title="课程"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
    </div>
    <div>
      <p class="comment-title">{{ lesson_name }}</p>
    </div>
    <div class="zonghe">
      <p style="font-size: 14px;">综合评价</p>
      <div class="star-group">
        <img v-for="(item,index) in starList" :key="index" :src="item.img" alt="" @click="chooseStar(item)">
      </div>
    </div>
    <!-- 标签 -->
    <div class="tag-group">
      <span v-for="(i,t) in pjTagsGroup" :key="t" :class="i.flag == true ? 'active-t':''" @click="checkTagsFun(i)">{{ i.name }}</span>
    </div>
    <textarea v-model="pjVal" placeholder="来说说您对本课程的感受吧~ 您的反馈和评价有助于我们为您提供更好的学习服务！"></textarea>
    <div class="fe-info-smwy">
      <p class="tt">分项评分：</p>
      <div class="f-inner">
        <ul class="list">
          <li v-for="(i,t) in fellList" :key="t">
            <p class="item_title">{{ i.title }}:
              <img v-if="i.user_score<5 && i.lastImgShow" src="https://newoss.zhulong.com/forum/202305/16/15/1684222659547814.png" alt="">
              <img v-else-if="i.user_score==5 || i.user_score==6" src="https://newoss.zhulong.com/forum/202305/16/15/1684222707733863.png" alt="">
              <img v-else-if="i.user_score==7 || i.user_score==8" src="https://newoss.zhulong.com/forum/202305/16/15/1684222741671702.png" alt="">
              <img v-else-if="i.user_score>8" src="https://newoss.zhulong.com/forum/202305/16/15/1684222750697205.png" alt="">
            </p>
            <div class="item">
              <div class="dissatisfaction">0分</div>
              <div class="progress">
                <el-slider
                  v-model="i.user_score"
                  :max="i.score"
                  :style="{'--text':`'${i.user_score}分'`}"
                  :show-tooltip="false"
                  @input="scoreInput()"
                  @change="scoreChange(i)"
                ></el-slider>
              </div>
              <div class="satisfaction">10分</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <button @click="commitpj()">提交</button>
  </div>
</template>
<script>
import { getLessonSatisfactionH5, myCommit } from '@/api/course.js'
import tool from '@/utils/tools.js'
import { Toast } from 'vant'
export default {
  data() {
    return {
      lesson_id: this.$route.query.lesson_id,
      lesson_name: this.$route.query.lesson_name,
      pjTagsGroup: [],
      pjTags: [],
      pjVal: '',
      starVal: '1',
      starList: [
        { 'value': '1', 'img': 'https://newoss.zhulong.com/forum/202305/18/10/1684375974930369.png' },
        { 'value': '2', 'img': 'https://newoss.zhulong.com/forum/202305/18/10/1684375977713743.png' },
        { 'value': '3', 'img': 'https://newoss.zhulong.com/forum/202305/18/10/1684375977713743.png' },
        { 'value': '4', 'img': 'https://newoss.zhulong.com/forum/202305/18/10/1684375977713743.png' },
        { 'value': '5', 'img': 'https://newoss.zhulong.com/forum/202305/18/10/1684375977713743.png' }
      ],
      fellList: []
    }
  },
  mounted() {
    this.getLessonSatisfactionH5()
  },
  methods: {
    scoreInput() {
      this.$forceUpdate()
    },
    scoreChange(i) {
      i.lastImgShow = true
      this.$forceUpdate()
    },
    // 获取满意度信息
    getLessonSatisfactionH5() {
      const info = {
        lesson_id: this.lesson_id
      }
      getLessonSatisfactionH5(info).then(res => {
        console.log(res, 'res')
        if (res.errNo == 0) {
          res.result.list.forEach(res => {
            res.score = 10
            res.user_score = 0
          })
          var pjTagsGroupArr = []
          res.result.info.quick_comment.forEach(res => {
            pjTagsGroupArr.push({ flag: false, name: res })
          })
          this.pjTagsGroup = pjTagsGroupArr
          this.fellList = res.result.list
        }
      })
    },
    // 星级评价
    chooseStar(item) {
      console.log(item)
      this.starList.forEach(res => {
        if (item.value < res.value) {
          res.img = 'https://newoss.zhulong.com/forum/202305/18/10/1684375977713743.png'
        } else {
          res.img = 'https://newoss.zhulong.com/forum/202305/18/10/1684375974930369.png'
        }
      })
      this.starVal = item.value
    },
    // 标签选择
    checkTagsFun(i) {
      console.log(i, 'i')
      i.flag = !i.flag
      if (i.flag) {
        this.pjTags.push(i.name)
      } else {
        this.pjTags.splice(this.pjTags.indexOf(i.name), 1)
      }
    },
    // 提交
    commitpj() {
      var score_list = []
      this.fellList.forEach(res => {
        score_list.push({ id: res.id, type: res.type, score: res.user_score })
      })
      var status = this.fellList.every((item) => {
        return item.user_score == 0
      })
      const info = {
        lesson_id: this.lesson_id,
        class_id: this.class_id || 0,
        live_id: this.live_id || 0,
        content: this.pjVal,
        score_list: JSON.stringify(score_list),
        attr: this.pjTags.join(','),
        rank: parseInt(this.starVal)
      }
      console.log(info, 'info')
      if (this.pjVal === '') {
        return this.$toast('请补全信息')
        // return this.$message.error('请补全信息')
      } else if (status) {
        return this.$toast('您还未打分')
      } else {
        myCommit(info).then(res => {
          console.log(res, 'res')
          if (res.errNo == 0) {
            Toast('评价成功')
            this.$router.go(-1)
          } else {
            Toast(res.msg)
          }
        })
      }
    },
    // 返回
    onClickLeft() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '课程评价返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go('-1')
      }
    },
    onClickRight() {
      console.log(2)
    }
  }
}
</script>
<style scoped lang='scss'>
.comment-title{
  text-align:center;
  margin: 45px 72px 30px;
  color: #ee2e2e;
  font-size: 36px;
  font-weight:bold;
}
.zonghe{
  text-align: center;
  .star-group{
    margin: 20px 0;
    img{
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }
}
.tag-group {
  width: 660px;
  margin: 0 auto;
  margin-bottom: 10px;
  span {
    display: inline-block;
    color: #666;
    border: 2px solid #dddddd;
    border-radius: 3px;
    padding: 10px 22px;
    cursor: pointer;
    margin-bottom: 9px;
    margin-left: 9px;
  }
  .active-t {
    color: #ee2e2e !important;
    background: #fff;
    border: 1px solid #ee2e2e !important;
  }
}
textarea {
  width: 660px;
  height: 150px;
  border: 1px solid #ddd;
  outline: none;
  margin-left: 54px;
  box-sizing: border-box;
  padding: 5px;
  resize: none;
}
textarea::-webkit-input-placeholder {
  color: #c4c4c4;
}
.fe-info-smwy{
  width: 585px;
  min-height: 316px;
  margin-left: 52px;
  margin-top: 10px;
  .tt{
    font-size: 28px;
    color: #000;
    margin-bottom: 20px;
    text-align: left !important;
    span{
      color: #999;
      font-size: 28px;
    }
  }
  .f-inner{
    width: 630px;
    font-size: 28px;
    .list{
      .item_title{
        display: flex;
        align-items: center;
        height: 50px;
        text-align: left;
        margin-bottom: 24px;
        font-size: 28px;
        img{
          width: 50px;
          margin-left: 6px;
          vertical-align: middle;
        }
      }
    }
    .list .item{
      // width: 750px;
      height: 90px;
      margin:0 auto 20px;
      display: flex;
      align-items: center;
      p{
        width: 130px;
        color: #000;
      }
      .dissatisfaction,.satisfaction{
        width: 80px;
        color: #999;
        display: inline-block;
        margin: 0 16px;
      }
      .progress{
        width: 390px;
        box-sizing: border-box;
        /deep/.el-slider__bar{
          background: #ee2e2e;
        }
        /deep/.el-slider__button{
          border:none;
          width: 60px;
          height: 60px;
          background: url('https://newoss.zhulong.com/edu/202007/09/31/095331y530t81smomzhyuy.png') no-repeat;
          background-size: 100% 100%;
          position: relative;
        }
        /deep/.el-slider__button::before{
          content: var(--text);
          position: absolute;
          font-size: 24px;
          width: 80px;
          height: 40px;
          line-height: 42px;
          top: -26px;
          left: 5px;
          border-radius: 3px;
          background: #ee2e2e;
          color: #fff;
        }
        /deep/.el-slider__button::after{
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          top: -7px;
          left: 10px;
          // background: url('../../assets/shoucang.png') no-repeat;
          background-position: -3px 3px;
          transform: rotate(180deg);
        }
      }
    }
  }
}
button{
  width: 90%;
  height: 60px;
  background: #ee2e2e;
  color: #fff;
  border: none;
  margin: 30px 0 80px 33px;
}
</style>
